import { customRangeFormat } from "@similarweb/pro-logic-components";
import type { Dayjs } from "dayjs";

export const getDiffCustomRangeParam = (from: Dayjs, to: Dayjs): string =>
    `${from.format(customRangeFormat)}-${to.format(customRangeFormat)}`;
